export * from '@devstroupe/services/confirmation/confirmation.service';
export * from '@devstroupe/services/confirmation/confirmation.types';
